import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    all: {count: 0, connversations: [], page: 1, pages: 1},
    unread: [],
    read: [],
  },
};

export const conversationSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {
    setConversations: (state, action) => {

        console.log("setConversations sent", action.payload);
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setConversations } = conversationSlice.actions;

export default conversationSlice.reducer;
